/*jshint esversion: 6 */
import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faCircle,
    faCircleUser,
    faCircleXmark,
    faClock,
    faTrashCan
} from '@fortawesome/free-regular-svg-icons';
import {
    faSquareInstagram,
    faGoogle
} from '@fortawesome/free-brands-svg-icons';
import { 
    faArrowRightFromBracket,
    faArrowUpFromBracket,
    faBars,
    faCaretRight,
    faCheck,
    faChevronUp,
    faChevronDown,
    faCircleInfo,
    faDownload,
    faEnvelope,
    faExclamation,
    faEye,
    faInfo,
    faLink,
    faMagnifyingGlass,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faPaperPlane,
    faPencil,
    faPenToSquare,
    faPlay,
    faPrint,
    faSort, 
    faSortDown, 
    faSortUp, 
    faUsers,
    faUserXmark,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
export function getFawLibrary() {
    const library= [
        faArrowRightFromBracket,
        faArrowUpFromBracket,
        faBars,
        faCaretRight,
        faCheck,
        faChevronUp,
        faChevronDown,
        faCircle,
        faCircleUser,
        faCircleXmark,
        faCircleInfo,
        faClock,
        faDownload,
        faEnvelope,
        faExclamation,
        faEye,
        faGoogle,
        faInfo,
        faSquareInstagram,
        faLink,
        faMagnifyingGlass,
        faMagnifyingGlassMinus,
        faMagnifyingGlassPlus,
        faPaperPlane,
        faPencil,
        faPenToSquare,
        faPlay,
        faPrint,
        faSort, 
        faSortDown, 
        faSortUp, 
        faTrashCan,
        faUsers,
        faUserXmark,
        faXmark
    ];
    return library;
}